import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../components/shared/AuthContext";


export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as any)?.from?.pathname || "/dashboard";

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    try {
      await login({ username, password });
      navigate(from, { replace: true });
    } catch (err: any) {
      setError(
        err.message || "Failed to log in. Please check your credentials.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      //   style={{ minHeight: "100vh", backgroundColor: "#f8f4e0" }}
      style={{ minHeight: "100vh", backgroundColor: "#f8f4e0" }}
    >
      <div className="col-12 col-sm-10 col-md-7 col-lg-5 col-xl-4">
        {/* Header */}
        <div className="text-center mb-4">
          {/* <div
            className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
            style={{ width: 64, height: 64, backgroundColor: "#f8f4e0" }}
          >
            <i className="bi bi-shop text-white fs-3"></i>
          </div> */}
          <h1 className="h4 fw-bold text-dark mb-1">Supplier Portal</h1>
        </div>

        {/* Card */}
        <div className="card shadow-sm border-0">
          <div className="card-body p-4">
            {error && (
              <div
                className="alert alert-danger d-flex align-items-start gap-2 py-2"
                role="alert"
              >
                <i className="bi bi-exclamation-triangle-fill flex-shrink-0 mt-1"></i>
                <span className="small">{error}</span>
              </div>
            )}

            <form onSubmit={handleSubmit} noValidate>
              <div className="mb-3">
                <label
                  className="form-label small fw-semibold text-secondary"
                  htmlFor="supplier-username"
                >
                  Username
                </label>
                <div className="input-group input-group-sm">
                  <span className="input-group-text bg-light border-end-0">
                    <i className="bi bi-person text-secondary"></i>
                  </span>
                  <input
                    type="text"
                    id="supplier-username"
                    className="form-control"
                    placeholder="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                    autoComplete="username"
                    autoFocus
                  />
                </div>
              </div>

              <div className="mb-4">
                <label
                  className="form-label small fw-semibold text-secondary"
                  htmlFor="supplier-password"
                >
                  Password
                </label>
                <div className="input-group input-group-sm">
                  <span className="input-group-text bg-light border-end-0">
                    <i className="bi bi-lock text-secondary"></i>
                  </span>
                  <input
                    type={showPassword ? "text" : "password"}
                    id="supplier-password"
                    className="form-control border-start-0 border-end-0"
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    autoComplete="current-password"
                  />
                  <button
                    type="button"
                    className="input-group-text bg-light border-start-0"
                    onClick={() => setShowPassword(!showPassword)}
                    tabIndex={-1}
                    aria-label={
                      showPassword ? "Hide password" : "Show password"
                    }
                  >
                    <i
                      className={`bi ${
                        showPassword ? "bi-eye-slash" : "bi-eye"
                      } text-secondary`}
                    ></i>
                  </button>
                </div>
              </div>

              <button
                type="submit"
                id="supplier-login-btn"
                className="btn btn-primary w-100"
                disabled={isLoading}
                style={{ backgroundColor: "#000000", borderColor: "#367fa9" }}
              >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Signing in...
                  </>
                ) : (
                  <>
                    <i className="bi bi-box-arrow-in-right me-2"></i>
                    Sign In
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
